export enum Wallets {
  Phantom = 'phantom',
  Solflare = 'solflare',
  Ledger = 'ledger',
  WalletConnect = 'walletconnect',
}

export const walletsMap = {
  [Wallets.Phantom]: 'Phantom',
  [Wallets.Solflare]: 'Solflare',
  [Wallets.Ledger]: 'Ledger',
  [Wallets.WalletConnect]: 'WalletConnect',
}
